import type { IFolder, TRootItems } from '../../../types/folders.types';
import { AccessType } from '@modules/access/types';
import type { TItem, TItemType } from '../../../types/items.types';

type TFolder = IFolder;

export type TSelectableDialogItem = TItem & {
  isAccessible: boolean;
  isTypeSelectable: boolean;
  isSelectable: boolean;
  isFolderType: boolean;
  disabledReason?: string;
};

type TBuildSelectableDialogItemsOptions = {
  parent: TFolder | TRootItems;
  items: TItem[];
  selectableTypes: TItemType[];
  checkManageAccess: boolean;
  isSelectable?: (parent: TFolder | TRootItems, item: TItem) => boolean;
  getDisabledReason?: (item: TItem) => string | undefined;
};

export const buildSelectableDialogItems = ({
  parent,
  items,
  selectableTypes,
  checkManageAccess,
  isSelectable = () => true,
  getDisabledReason,
}: TBuildSelectableDialogItemsOptions): TSelectableDialogItem[] =>
  items.map((item) => {
    // TODO: we should offer an ability to check for all accessRights (READ, EDIT, MANAGE).
    const isAccessible = checkManageAccess ? item.accessRight === AccessType.MANAGE : true;
    const isTypeSelectable = selectableTypes.includes(item.type) && isSelectable(parent, item);
    const disabledReason = getDisabledReason?.(item);
    const isItemSelectable = isAccessible && isTypeSelectable && !disabledReason;
    return {
      ...item,
      isAccessible,
      isTypeSelectable,
      isSelectable: isItemSelectable,
      isFolderType: item.type === 'FOLDER',
      disabledReason,
    };
  });
